import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "../data/blogPosts";
import { SectionEyebrow } from "../components/SectionEyebrow";

const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("es-CO", { day: "2-digit", month: "long", year: "numeric" });
};

export default function Blog() {
    const [featured, ...rest] = BLOG_POSTS;
    return (
        <>
            <section className="topo-bg py-20 lg:py-28" data-testid="blog-hero">
                <div className="container-fe max-w-4xl">
                    <SectionEyebrow>Blog y noticias</SectionEyebrow>
                    <h1 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-brand-navy leading-[1.05]">
                        Historias del territorio, contadas con honestidad.
                    </h1>
                    <p className="mt-7 text-lg text-muted-foreground leading-relaxed max-w-2xl">
                        Reflexiones, balances, voces de la comunidad y noticias de nuestros programas.
                        Sin retoques, sin asistencialismo.
                    </p>
                </div>
            </section>

            <section className="py-16 lg:py-20 bg-white">
                <div className="container-fe">
                    {/* Featured */}
                    <Link
                        to={`/blog/${featured.slug}`}
                        data-testid={`blog-featured-${featured.slug}`}
                        className="group grid lg:grid-cols-2 gap-10 items-center rounded-3xl overflow-hidden border border-black/5 bg-white hover:border-brand-green/30 transition-all"
                    >
                        <div className="aspect-[4/3] lg:aspect-square overflow-hidden">
                            <img
                                src={featured.image}
                                alt={featured.title}
                                style={featured.imagePosition ? { objectPosition: featured.imagePosition } : undefined}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                            />
                        </div>
                        <div className="p-8 lg:p-12">
                            <div className="flex items-center gap-3 text-xs uppercase tracking-wider font-bold">
                                <span className="text-brand-green">{featured.category}</span>
                                <span className="text-muted-foreground">{formatDate(featured.date)}</span>
                            </div>
                            <h2 className="mt-4 font-display font-bold text-2xl sm:text-3xl lg:text-4xl text-brand-navy leading-tight group-hover:text-brand-green transition-colors">
                                {featured.title}
                            </h2>
                            <p className="mt-5 text-muted-foreground leading-relaxed">{featured.excerpt}</p>
                            <div className="mt-6 inline-flex items-center gap-2 text-brand-green font-semibold">
                                Leer historia <ArrowRight size={16} />
                            </div>
                        </div>
                    </Link>

                    {/* Grid */}
                    <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {rest.map((p) => (
                            <Link
                                key={p.slug}
                                to={`/blog/${p.slug}`}
                                data-testid={`blog-card-${p.slug}`}
                                className="group rounded-2xl overflow-hidden border border-black/5 bg-white hover:border-brand-green/30 hover:-translate-y-1 transition-all"
                            >
                                <div className="aspect-[4/3] overflow-hidden bg-muted">
                                    <img
                                        src={p.image}
                                        alt={p.title}
                                        style={p.imagePosition ? { objectPosition: p.imagePosition } : undefined}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                                <div className="p-6">
                                    <div className="flex items-center gap-3 text-xs uppercase tracking-wider font-bold">
                                        <span className="text-brand-green">{p.category}</span>
                                        <span className="text-muted-foreground">{formatDate(p.date)}</span>
                                    </div>
                                    <h3 className="mt-3 font-display font-semibold text-brand-navy text-lg leading-snug group-hover:text-brand-green transition-colors">
                                        {p.title}
                                    </h3>
                                    <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{p.excerpt}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}
